var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPerdidaSeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#522d8e;}.cls-3{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-perdida-se\xF1al") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_11",
    "data-name": 11
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 138.76,
    y: 81.82,
    width: 15.63,
    height: 62.5,
    rx: 4.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 116.17,
    y: 101.91,
    width: 15.63,
    height: 42.41,
    rx: 4.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 93.58,
    y: 115.07,
    width: 15.63,
    height: 29.24,
    rx: 4.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 71,
    y: 129.7,
    width: 15.63,
    height: 14.62,
    rx: 4.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M114.62,41.34a72.55,72.55,0,1,0,72.55,72.55A72.55,72.55,0,0,0,114.62,41.34Zm0,138.45A65.89,65.89,0,0,1,68,67.28l.19-.18L161,160.74a65.69,65.69,0,0,1-46.34,19Zm50.83-23.95L73.16,62.66a65.9,65.9,0,0,1,92.29,93.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPerdidaSeal);
export default __webpack_public_path__ + "static/media/ic-perdida-señal.263caa4836fc600635f0e9b34b5323cc.svg";
export { ForwardRef as ReactComponent };